import {
  AuthorizationContextInput,
  DeleteUnitLayoutInput,
  UnitLayout,
} from "@examspark/types";

import {
  getCourseCalendar as getCourseCalendarGql,
  getCourseObjectives as getCourseObjectivesGql,
} from "../queries/classroom";
import {
  createUnitLayout as createUnitLayoutGql,
  updateUnitLayout as updateUnitLayoutGql,
  deleteUnitLayout as deleteUnitLayoutGql,
  getCourseVerification as getCourseVerificationGql,
  getCourseWithUnits as getCourseWithUnitsGql,
  getCourseWithUnitsAndUnitIds as getCourseWithUnitsAndUnitIdsGql,
  listUnitLayouts,
} from "../queries/course";
import { getUnit as getUnitGql } from "../queries/unit";
import { typedGql, typedGqlMutation } from "../utils";

export const getCourseWithUnits = async (
  courseId: string,
  authorizationContext: AuthorizationContextInput,
) => {
  return (
    await typedGql(getCourseWithUnitsGql)({
      input: {
        id: courseId,
        sk: "course#v0",
      },
      authorizationContext,
    })
  ).data?.getCourse;
};

export const getCourseWithUnitsAndUnitIds = async (
  courseId: string,
  authorizationContext: AuthorizationContextInput,
) => {
  return (
    await typedGql(getCourseWithUnitsAndUnitIdsGql)({
      input: {
        id: courseId,
        sk: "course#v0",
      },
      authorizationContext,
    })
  ).data?.getCourse;
};

// todo: page once it's possible to have more than 2 layouts
export const listUnitLayoutsByCourse = async (
  courseId: string,
  authorizationContext: AuthorizationContextInput,
) => {
  if (!authorizationContext.workspaceId) {
    throw new Error("authorizationContext.workspaceId is required");
  }

  return (
    await typedGql(listUnitLayouts)({
      input: {
        id: courseId,
        workspaceId: authorizationContext.workspaceId,
      },
      authorizationContext,
    })
  ).data?.listUnitLayouts.items;
};

export const createUnitLayout = async (
  input: UnitLayout,
  authorizationContext: AuthorizationContextInput,
) => {
  return await typedGqlMutation(createUnitLayoutGql)({
    input,
    authorizationContext,
  });
};

export const updateUnitLayout = async (
  input: UnitLayout,
  authorizationContext: AuthorizationContextInput,
) => {
  return await typedGqlMutation(updateUnitLayoutGql)({
    input,
    authorizationContext,
  });
};

export const deleteUnitLayout = async (
  input: DeleteUnitLayoutInput,
  authorizationContext: AuthorizationContextInput,
) => {
  return await typedGqlMutation(deleteUnitLayoutGql)({
    input,
    authorizationContext,
  });
};

export const getCourseVerification = async (
  courseId: string,
  authorizationContext?: AuthorizationContextInput,
) =>
  typedGql(getCourseVerificationGql)({
    input: {
      id: courseId,
      sk: "course#v0",
    },
    authorizationContext,
  });

export const getCourseCalendar = async (
  courseId: string,
  authorizationContext: AuthorizationContextInput,
) => {
  return (
    await typedGql(getCourseCalendarGql)({
      input: {
        id: courseId,
        sk: "course#v0",
      },
      authorizationContext,
    })
  ).data?.getCourseCalendar;
};

export const getCourseObjectives = async (
  courseId: string,
  authorizationContext: AuthorizationContextInput,
) => {
  return (
    await typedGql(getCourseObjectivesGql)({
      input: {
        id: courseId,
        sk: "course#v0",
      },
      authorizationContext,
    })
  ).data?.getCourse;
};

export const getUnit = async (unitId: string) => {
  return (
    await typedGql(getUnitGql)({
      input: {
        id: unitId,
        sk: "unit#v0",
      },
    })
  ).data?.getUnit;
};
